<template>
	<div style="background-color: #000000;">
		<h2 style="text-align: center;color: white;background-color: #0F0B26;padding: 20px;margin-bottom: 20px;">停车数据统计</h2>
		<div style="display: flex;margin-bottom: 20px;">
			<kfxq2 style="width: 32%;" ></kfxq2>
			<jrqk2 style="margin:0 0.5%;width: 35%;"  ></jrqk2>
			<rcxx2 style="width: 32%;" ></rcxx2>
		</div>
		<div style="display: flex;margin-bottom: 20px;">
			
			<rcrzqs2  style="width: 32%;" ></rcrzqs2>
			<fwtj2 style="margin:0 0.5%;width: 35%;" ></fwtj2>
			<fwpj2 style="width: 32%;" ></fwpj2>
			<!-- <kfxq :kfxq="kfxq" :isTrue='isTrue'></kfxq> -->
		</div>
		<!-- <div style="display: flex;">
			<fwtj style="margin-right: 20px;" :fwtj="fwtj" :isTrue='isTrue'></fwtj>
			<fwpj :fwpj="fwpj" :isTrue='isTrue'></fwpj>
		</div> -->
	</div>
</template>

<script>
	import rcrzqs2 from "./component/rcrzqs2.vue"
	import jrqk2 from "./component/jrqk2.vue"
	import rcxx2 from "./component/rcxx2.vue"
	import kfxq2 from "./component/kfxq2.vue"
	import fwtj2 from "./component/fwtj2.vue"
	import fwpj2 from "./component/fwpj2.vue"
	export default {
		components: {
			rcrzqs2,jrqk2,rcxx2,kfxq2,fwtj2,fwpj2
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
			
		},
		methods: {

		}
	}
</script>

<style scoped="scoped">


</style>
